// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"_2VK2OOz","buttons":"_1E0AED1"};